/* eslint-disable @next/next/no-before-interactive-script-outside-document */
'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
declare global {
  interface Window {
    _rwq: any;
    rewardful: any;
  }
}
export function RewardfulScript() {
  const pathname = usePathname();
  useEffect(() => {
    // Track pageviews on route changes
    if (typeof window.rewardful === 'function') {
      window.rewardful('track', 'pageview');
    }
  }, [pathname]);
  return <>
      <Script id="rewardful-init" strategy="beforeInteractive" dangerouslySetInnerHTML={{
      __html: `(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`
    }} data-sentry-element="Script" data-sentry-source-file="RewardfulScript.tsx" />
      <Script id="rewardful-tracking" strategy="afterInteractive" src="https://r.wdfl.co/rw.js" data-rewardful={process.env.NEXT_PUBLIC_REWARDFUL_KEY} onError={e => {
      console.error('Rewardful script failed to load:', e);
    }} data-sentry-element="Script" data-sentry-source-file="RewardfulScript.tsx" />
    </>;
}